/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_BusInputs */

const fr_vehicle_type_bus = /** @type {(inputs: Vehicle_Type_BusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bus`)
};

const en_vehicle_type_bus = /** @type {(inputs: Vehicle_Type_BusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bus`)
};

/**
* | output |
* | --- |
* | "Bus" |
*
* @param {Vehicle_Type_BusInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_bus = /** @type {((inputs?: Vehicle_Type_BusInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_BusInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_bus(inputs)
	return en_vehicle_type_bus(inputs)
});